import useData from "../app/useData";

import ElementListItem from "./ElementListItem";
import ElementListAdd from "./ElementListAdd";

import "./ElementList.css";

const ElementList: React.FC<{}> = () => {
	const {
		displayedElements,
		containers,
		elements,
		elementsInContainers,
		containerEditingId: containerId,
		elementEditing,
		selectElement,
		unselectElement,
		addElementToContainer,
		deleteElementFromContainer,
		deleteElement,
		moveElement,
		rotateElement
	} = useData();

	const onElementAdd: (element: ElementDefinitionType) => void = element => {
		if (containerId) {
			addElementToContainer(element.id, containerId);
		}
	};
	const onElementRemove: (elementId: string) => void = elementId =>
		containerId && deleteElementFromContainer(elementId, containerId);
	const onElementDefRemove: (elementId?: string) => void = elementId =>
		elementId && deleteElement(elementId);

	const container = (containerId && containers.get(containerId)) || undefined;

	const elementsListed = displayedElements.map(id => elements.hasAndGet(id));
	elementsListed.sort((elt1, elt2) => {
		const inCnt1 = container?.content.includes(elt1.id);
		const inCnt2 = container?.content.includes(elt2.id);

		if (inCnt1 === inCnt2) {
			return elt1.id.localeCompare(elt2.id);
		} else if (inCnt1) {
			return -1;
		}
		return 1;
	});

	return (
		<div className="ElementList">
			{elementsListed.map(element => (
				<ElementListItem
					key={element.id}
					element={element}
					elementInCanvas={elementsInContainers.get(element.id)}
					selected={element.id === elementEditing?.elementId}
					onSelectElement={selectElement}
					onUnselect={unselectElement}
					onElementAdd={onElementAdd}
					onElementRemove={onElementRemove}
					onElementDefRemove={onElementDefRemove}
					onElementMove={moveElement}
					onElementRotate={rotateElement}
				/>
			))}
			<ElementListAdd />
		</div>
	);
};

export default ElementList;
